import { defineStore } from 'pinia';
import { syncOfflineQueue } from '../lib/api';
export const useConnectivityStore = defineStore('connectivity', {
    state: () => ({ online: navigator.onLine, initialNoticeShown: false, socketConnected: false }),
    actions: {
        start() {
            window.addEventListener('online', async () => {
                this.online = true;
                await syncOfflineQueue();
            });
            window.addEventListener('offline', () => {
                this.online = false;
                if (!this.initialNoticeShown) {
                    this.initialNoticeShown = true;
                    alert('Connessione assente. CasaMB continua a funzionare dalla cache locale e sincronizzerà le modifiche appena possibile.');
                }
            });
        }
    }
});
